import { useMemo } from 'react';

import { expVal } from '@confluence/feature-experiments';

export const useEditorFeatureFlags = () => {
	// IMPORTANT: If you add a new feature flag here, please make sure to add it to the
	// `featureFlagsPluginOptions` function in 'packages/editor/editor-presets-confluence/src/presets/full-page/pluginOptions/featureFlagsPluginOptions.ts`.
	return useMemo(
		() => ({
			/**
			 * This feature flag has completed rollout in Confluence and is to be cleaned up from LD
			 * but cannot yet be cleaned up from editor component as pending rollout in other products first
			 */
			'lp-link-picker': true,
			'table-drag-and-drop': expVal<boolean>(
				'platform_editor_tables_drag_and_drop',
				'isEnabled',
				false,
			),
			'table-with-fixed-column-widths-option': true,
		}),
		[],
	);
};
